export enum  ENUM_ORDER_BY {
    PRECIO_BAJO = 1,
    PRECIO_ALTO = 2,
    CONVENIENTE = 3,
    MENOR_TIEMPO = 4,
    MAYOR_TIEMPO = 5,
}